<div class="main-wrap">
  <p-toast></p-toast>
  <div class="body">
    <p *ngIf="bookings">
      <!-- Total bookings: {{filteredBookings.length}} -->
    </p>
    <div>
      <p-multiSelect [options]="exportOptions" optionLabel="name" [(ngModel)]="selectedOptions"></p-multiSelect>
      <p-button label="export" (onClick)="exportBookings()"></p-button>
    </div>
    <div class="search-box" [formGroup]="searchForm">
      <div class="ui-inputgroup">
        <input pInputText placeholder="search term here" type="text" formControlName="searchTerm">
        <span class="ui-inputgroup-addon"><i class="pi pi-search" style="line-height: 1.25;"></i></span>
      </div>
    </div>
    <div class="search-option-item">
      <span>
        <span>
          Sort by starting date
        </span>
        <p-button icon="pi pi-arrow-circle-up" (onClick)="sortByStartDate(false)"></p-button>
        <p-button icon="pi pi-arrow-circle-down" (onClick)="sortByStartDate(true)"></p-button>
      </span>
    </div>
    <div [formGroup]="dateSearchForm" class="search-option-item">
      <span>
        Starting date between:
      </span>
      <p-calendar [monthNavigator]="true" formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
      <span>
        And:
      </span>
      <p-calendar [monthNavigator]="true" formControlName="endDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
      <p-button icon="pi pi-arrow-circle-right" (onClick)="searchBookingsByDates()"></p-button>
    </div>
    <div>
      <p-button label="Reset" (onClick)="resetSearch()"></p-button>
    </div>
    <div *ngIf="bookingsLoading">
      <i class="pi pi-spin pi-spinner" style="font-size: 3em; color: grey;"></i>
    </div>
    <div *ngIf="bookingsRaw.length == 0">
      <p>No booking found.</p>
    </div>
    <div class="booking-box">
      <ng-container *ngIf="filteredBookings | async as data">
        <p-table selectionMode="single" [value]="data" *ngIf="searchForm.get('searchTerm')!.value != ''">
          <ng-template pTemplate="header">
            <tr>
              <th>ID</th>
              <th id="active-head">Active</th>
              <th>School</th>
              <th>Firstname</th>
              <th>Lastname</th>
              <th>Start</th>
              <th>End</th>
              <th>Vademecum</th>
              <th>Photo permission</th>
              <th id="picture-head">Profile picture</th>
              <th>Language</th>
              <th>Duration</th>
              <th>Created by</th>
            </tr>

          </ng-template>
          <ng-template pTemplate="body" let-booking>
            <tr [pSelectableRow]="booking">
              <td id="id">
                {{booking.id}}
              </td>
              <td id="active" *ngIf="booking.isActive">
                X
              </td>
              <td id="active" *ngIf="!booking.isActive">
              </td>
              <td>
                {{booking.school.name}}
              </td>
              <td id="first-name">
                <a routerLink="/management/edit-booking/{{booking.id}}">
                  {{booking.firstName | titlecase}}
                </a>
              </td>
              <td id="last-name">
                <a routerLink="/management/edit-booking/{{booking.id}}">
                  {{booking.lastName | titlecase}}
                </a>
              </td>
              <td id="start">
                {{booking.startDate | dateFormat: "DD/MM/YYYY"}}
              </td>
              <td id="end">
                {{booking.endDate | dateFormat: "DD/MM/YYYY"}}
              </td>
              <td *ngIf="booking.hasVademecum" id="vademecum">
                <i class="pi pi-spin pi-spinner" style="font-size: 3em" *ngIf="booking.downloadingPdf"></i>
                <p-button label="Download" (onClick)="downloadPdf(booking)" *ngIf="!booking.downloadingPdf"></p-button>
              </td>
              <td *ngIf="!booking.hasVademecum" id="vademecum">
              </td>
              <td>
                <i class="pi pi-check" *ngIf="booking.hasAutorizationForStudentPicture"></i>
              </td>
              <td *ngIf="!booking.hasPicture">

              </td>
              <td *ngIf="booking.hasPicture">
                X
              </td>
              <td>
                {{booking.language.name | titlecase}}
              </td>
              <td>
                {{booking.duration}}
              </td>
              <td>
                {{booking.createdBy.name}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
          </ng-template>
        </p-table>
      </ng-container>
      <p-table selectionMode="single" [value]="bookingsView" *ngIf="searchForm.get('searchTerm')!.value == ''">
        <ng-template pTemplate="header">
          <tr>
            <td colspan="13">
              <p-paginator [first]="first" [rows]="50" [totalRecords]="recordNumber"
                (onPageChange)="updateView($event)"></p-paginator>
            </td>
          </tr>
          <tr>
            <th>ID</th>
            <th id="active-head">Active</th>
            <th>School</th>
            <th>Firstname</th>
            <th>Lastname</th>
            <th>Start</th>
            <th>End</th>
            <th>Vademecum</th>
            <th>Photo permission</th>
            <th id="picture-head">Profile picture</th>
            <th>Language</th>
            <th>Duration</th>
            <th>Created by</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-booking>

          <tr [pSelectableRow]="booking">
            <td id="id">
              {{booking.id}}
            </td>
            <td id="active" *ngIf="booking.isActive">
              X
            </td>
            <td id="active" *ngIf="!booking.isActive">
            </td>
            <td>
              {{booking.school.name}}
            </td>
            <td id="first-name">
              <a routerLink="/management/edit-booking/{{booking.id}}">
                {{booking.firstName | titlecase}}
              </a>
            </td>
            <td id="last-name">
              <a routerLink="/management/edit-booking/{{booking.id}}">
                {{booking.lastName | titlecase}}
              </a>
            </td>
            <td id="start">
              {{booking.startDate | dateFormat: "DD/MM/YYYY"}}
            </td>
            <td id="end">
              {{booking.endDate | dateFormat: "DD/MM/YYYY"}}
            </td>
            <td *ngIf="booking.hasVademecum" id="vademecum">
              <i class="pi pi-spin pi-spinner" style="font-size: 3em" *ngIf="booking.downloadingPdf"></i>
              <p-button label="Download" (onClick)="downloadPdf(booking)" *ngIf="!booking.downloadingPdf"></p-button>
            </td>
            <td *ngIf="!booking.hasVademecum" id="vademecum">
            </td>
            <td>
              <i class="pi pi-check" *ngIf="booking.hasAutorizationForStudentPicture"></i>
            </td>
            <td *ngIf="!booking.hasPicture">

            </td>
            <td *ngIf="booking.hasPicture">
              X
            </td>
            <td>
              {{booking.language.name | titlecase}}
            </td>
            <td>
              {{booking.duration}}
            </td>
            <td>
              {{booking.createdBy.name}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="13">
              <p-paginator [first]="first" [rows]="50" [totalRecords]="recordNumber"
                (onPageChange)="updateView($event)"></p-paginator>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>